export default __webpack_public_path__ + "c2d6e66673965be2f4f4bc317695c5e5.png";